import type { ServiceResponse } from "../core/service";
import type {
  AuthLoginRequest,
  AuthLoginResponse,
  AuthLogoutResponse,
} from "../schemas/auth";

import { BaseService } from "../core/service";
import {
  authLoginResponseSchema,
  authLogoutResponseSchema,
} from "../schemas/auth";

export class AuthService extends BaseService {
  public async login(
    body: AuthLoginRequest,
  ): Promise<ServiceResponse<AuthLoginResponse>> {
    return this.post("/auth/login", {
      data: body,
      responseSchema: authLoginResponseSchema,
    });
  }

  public async logout(): Promise<ServiceResponse<AuthLogoutResponse>> {
    return this.post("/auth/logout", {
      responseSchema: authLogoutResponseSchema,
    });
  }
}
